import React, { useState } from 'react';
import './Account.css';

const CustomerAccount = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [user, setUser] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // For simplicity, just set user data without backend
    setUser(formData);
    alert(isLogin ? 'Logged In Successfully' : 'Account Created Successfully');
  };

  return (
    <div className="customer-account">
      {!user ? (
        <div className="form-container">
          <h2>{isLogin ? 'Login' : 'Create Account'}</h2>
          <form onSubmit={handleSubmit}>
            {!isLogin && (
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            )}
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <button type="submit">{isLogin ? 'Login' : 'Register'}</button>
          </form>
          <p onClick={() => setIsLogin(!isLogin)} className="toggle-btn">
            {isLogin ? 'Don’t have an account? Register' : 'Already have an account? Login'}
          </p>
        </div>
      ) : (
        <div className="profile-container">
          <h2>Welcome, {user.name || 'Customer'}!</h2>
          <p>Email: {user.email}</p>
          <button onClick={() => setUser(null)}>Logout</button>
        </div>
      )}
    </div>
  );
};

export default CustomerAccount;
